import React, { useState } from 'react';
import { InfoBox } from '@react-google-maps/api';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import ImageCarousel from 'components/layout/ImageCarousel/ImageCarousel';

const InfoBoxWrapper = ({ markerState, setMarkerState }) => {

  const infoBoxOptions = {
    maxWidth: 0,
    zIndex: null,
    alignBottom: true,
    infoBoxClearance: new window.google.maps.Size(50, 50),
    enableEventPropagation: true,
    boxStyle: {
      backgroundColor: 'rgba(233,233,233,0.95)',
      borderRadius: '5px',
      border: '1px solid black',
      padding: '5px',
      width: '252px',
      overflow: 'initial',
      // opacity: 0.95,
    }
  }
  const styles = {
    imagesContainer: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      // maxHeight: '245px',
      maxHeight: '120px',
      overflowY: 'auto',
    },
    image: {
      padding: '1px'
    },
    center: {
      textAlign: 'center'
    },
    pricepersqft: {
      fontSize: '10px',
      paddingLeft: '0.5rem',
    }
  }

  if (markerState.selectedMarker.isSubject) {
    infoBoxOptions.pixelOffset = new window.google.maps.Size(-145, -41);
  } else {
    infoBoxOptions.pixelOffset = new window.google.maps.Size(-145, -35);
  }

  // Handling for comps in propertyUW vs txnOpps in auctionUW - comps use livingArea field from GUD
  const sqft = markerState.selectedMarker.livingArea || markerState.selectedMarker.sqft;

  return (
    <InfoBox
      position={new window.google.maps.LatLng(markerState.selectedMarker.latitude, markerState.selectedMarker.longitude)}
      options={infoBoxOptions}
      visible={markerState.isInfoBoxOpen}
      zIndex={1}
    >
      <>
        <img alt='closeButton' src="http://www.google.com/intl/en_us/mapfiles/close.gif" align="right" style={{ position: "relative", cursor: "pointer", margin: 2 }} onClick={() => setMarkerState({ ...markerState, isInfoBoxOpen: false })}></img>
        <div>
          <div><b>{markerState.selectedMarker.street || markerState.selectedMarker.streetAddress}, {markerState.selectedMarker.city}, {markerState.selectedMarker.state}, {markerState.selectedMarker.zipCode || markerState.selectedMarker.zipcode}</b></div>
          {markerState.selectedMarker.price &&
            <div>
              <b>${(markerState.selectedMarker.price).toLocaleString(undefined, { maximumFractionDigits: 2 })}</b>
              {sqft &&
                <span style={styles.pricepersqft}>${(markerState.selectedMarker.price / sqft).toFixed(2)} per sqft</span>
              }
            </div>
          }
          <div>{markerState.selectedMarker.beds} bd / {markerState.selectedMarker.baths} ba / {sqft} sqft</div>
          {markerState.isFetchingImages ?
            <div style={styles.center}>Loading...</div>
            :
            markerState.selectedMarkerImages.length > 0 ?
              <div style={styles.imagesContainer}>
                {markerState.selectedMarkerImages && markerState.selectedMarkerImages.length > 0 && 
                  <ImageCarousel square imageSources={markerState.selectedMarkerImages} showAsGrid gridThumbnailCount={6} />
                }
              </div>
              :
              <div style={styles.center}>There are no images</div>
          }
        </div>
      </>
    </InfoBox>
  )
};

const mapDispatchToProps = (dispatch) => ({

});

export default compose(
  connect(null, mapDispatchToProps)
)(InfoBoxWrapper);
